
import { useEffect, useState } from '../../common/common';
import axiosJWT from '../../secureAPI/axiosJWT';
import useGetUserData from '../../secureAPI/GetUserData';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { showToast } from '../../Utils/toastUtils';
import * as XLSX from 'xlsx';
const MidViewUsers = () => {


    const { users, userPlan, Remainuser, subUser } = useGetUserData();
    const [isLoading, setisLoading] = useState(false);
    const [lgShow, setLgShow] = useState(false);

    const [seacrh, setSearch] = useState('');
    const [filteredUsers, setFilteredCUsers] = useState([]);
    const [sheetdata, setSheetdata] = useState([]);
    const [userData, setUserdata] = useState([]);

    const [permissionstringdata, setPermissionStringdata] = useState([]);
    const [lgShow1, setLgShow1] = useState(false);
    useEffect(() => {
        getUsers();
    }, []);

    const exporttoExcelData = () => {
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(sheetdata);
        XLSX.utils.book_append_sheet(wb, ws, 'Users');
        XLSX.writeFile(wb, "Selzor_Users.xlsx");
    }


    const handlemodalshow = (permission_string) => {
        const permission_array = permission_string.split(',');
        setPermissionStringdata(permission_array);
        setLgShow1(true);
    }
    const handlemodalhide = () => {
        setLgShow1(false);
    }
    useEffect(() => {
        const filtered_result = userData.filter((userData) => {
            return (
                userData.full_name.toLowerCase().match(seacrh.toLowerCase())
            );
        });
        setFilteredCUsers(filtered_result);
    }, [seacrh]);
    const getUsers = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetSellerUsers`, { app: 0 }, { withCredentials: true })
                .then((res) => {
                    StopLoading(setisLoading);
                    if (res.data.success === 1) {
                        setUserdata(res.data.data);
                        setFilteredCUsers(res.data.data);
                        setSheetdata(res.data.data);
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(res.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading)
                    showToast('Something went wrong ! please try again ', 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find seller details, please try again later ", 'error');
        }
    }

    const removeUser = async (user_id, check) => {
        if (window.confirm(`Are you sure you want to ${check === 1 ? 'Remove' : 'Active'} User?`)) {
            StartLoading(setisLoading);
            try {
                await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/DeleteUser`, { user_id, app: 0, check }, { withCredentials: true })
                    .then((res) => {
                        if (res.data.success === 1) {

                            StopLoading(setisLoading)
                            showToast(res.data.message, 'success');
                            // data_len = res.data.data.length;

                            setUserdata(res.data.data);
                            setFilteredCUsers(res.data.data);
                        }
                        else if (res.data.success === 0) {

                            StopLoading(setisLoading)
                            showToast(res.data.message, 'error');
                        }
                    })
                    .catch((err) => {
                        StopLoading(setisLoading)
                        showToast('something went wrong ! please try later', 'error');
                    });
            } catch (err) {
                StopLoading(setisLoading);
                showToast("Failed to delete user , please try again later ", 'error');
            }
        }

    }
    return {
        users, userPlan, Remainuser, subUser, isLoading, seacrh, setSearch, filteredUsers, setFilteredCUsers, sheetdata, setSheetdata, exporttoExcelData, handlemodalshow, permissionstringdata, setPermissionStringdata, lgShow1, setLgShow1, handlemodalhide, userData, removeUser, lgShow, setLgShow

    }
}

export default MidViewUsers